// extracted by mini-css-extract-plugin
export default {"wrapper":"_404_wrapper__qprmp","preHeader":"_404_preHeader__yVSDv","header":"_404_header__2Gfw2","guiltyHeader":"_404_guiltyHeader__tWIlX","imgRow":"_404_imgRow__6aQ-P"};